import React from 'react';
import { useTranslation } from 'react-i18next';
import {menuDb} from '../../constants/data';
import certificateImg from '../../assets/images/logo/certificate.avif';
import {Link} from "react-router-dom";
import settings from "../../constants/settings";
import {EmailEnvelopIcon, phoneCalling} from "../../constants/svgIcons";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className={'pt-10 bg-black text-white'}>
      <div
        className={`md:w-theme-container w-mobile-container mx-auto h-auto
          ${window.innerWidth <= 768 ? "":"upper-footer"} 
        `}
      >
        <div className="grid grid-cols-1 md:grid-cols-[45%_auto] pb-10">
          <div className="h-auto">
            <div className="w-60 py-8">
              <img className="w-full" src={certificateImg} alt=""/>
            </div>
            <div className="md:text-lg md:w-9/12 text-base">
              {t('common.aboutUsDescription')}
            </div>
              <div className="grid grid-cols-2 md:flex justify-start items-start gap-3 md:gap-5 lg:gap-10 mt-10 bg-red-3000">
                <div className="flex flex-col items-start gap-1">
                  <div className="flex gap-2">
                    {/*{phoneIcon()}*/}
                    {phoneCalling('#ffffff',28)}
                    <div className="md:text-xl text-xl">{t('common.phone')}</div>
                  </div>
                  <div>
                    <ul className="my-2">
                      <li
                        className="text-lg md:text-xl hover:underline text-white hover:text-blue-800 transition-transform duration-200 flex flex-col items-start "
                      >
                        <a href="tel:+97142829613">+971 4 2829 613</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="flex flex-col items-start gap-1">
                  <div className="flex gap-2">
                    <EmailEnvelopIcon color="#ffffff" pixel={33} />
                    <div className="md:text-xl text-xl">{t('common.email')}</div>
                  </div>
                  <div>
                    <ul className="">
                      <li
                        className="text-lg md:text-xl hover:underline text-white hover:text-blue-800 transition-transform duration-200 flex flex-col items-start "
                      >
                        <a href="mailto:info@mesoft.ae">info@mesoft.ae</a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/*<div className=" col-span-2 flex flex-col items-start gap-1">*/}
                {/*  <div className="flex gap-2">*/}
                {/*    {<AddressPin color="#0080FF" pixel={27.5} />}*/}
                {/*    <div className="md:text-xl text-xl">{t('common.location')}</div>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <ul className="mt-2">*/}
                {/*      <li*/}
                {/*        className="md:text-base text-sm hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start "*/}
                {/*      >*/}
                {/*        /!*<a target="_blank" href="https://maps.app.goo.gl/WbUrhCfXrEvJPaYS7">{t('common.addressDescription')}</a>*!/*/}
                {/*        <a*/}
                {/*          target="_blank" href="https://maps.app.goo.gl/WbUrhCfXrEvJPaYS7"*/}
                {/*          className="w-full flex flex-col justify-center items-start">*/}
                {/*          /!*<div className="md:text-base text-sm">{t('common.addressDescription')}</div>*!/*/}
                {/*          <div className="md:text-base text-sm">MESOFT Business Solutions L.L.C</div>*/}
                {/*          <div className="md:text-base text-sm">P.O. Box: 5012, Airport Road (Near Terminal 1)</div>*/}
                {/*          <div className="md:text-base text-sm">Dubai, United Arab Emirates.</div>*/}
                {/*        </a>*/}
                {/*      </li>*/}
                {/*    </ul>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
          </div>
          <div className="">
            <div className="grid grid-cols-2 md:grid-cols-2">
              <div className="mt-10">
                {/*<SlideUp>*/}
                <div className="md:text-2xl text-xl">{t('common.products')}</div>
                {/*</SlideUp>*/}
                <ul className="mt-8">
                  {menuDb.mainMenu[1].submenu
                    .filter(item => item.footerShow === true)
                    .map((item, index) => (
                    <div
                      key={index}
                    >
                      {/*<SlideUp>*/}
                      <li
                        key={item.id}
                        className="md:text-base text-sm hover:translate-x-4 hover:underline hover:text-theme-color transition-transform duration-200 mb-3 "
                      >
                        <Link to={`${settings.domain}${item.routePath}`}>{t(`common.${item.translateKey}`)}</Link>
                      </li>
                      {/*</SlideUp>*/}
                    </div>
                  ))}
                </ul>
              </div>
              <div className="mt-10">
                {/*<SlideUp>*/}
                <div className="md:text-2xl text-xl">{t('common.services')}</div>
                {/*</SlideUp>*/}
                <ul className="mt-8">
                  {menuDb.mainMenu[2].submenu.map((item, index) => (
                    <div
                      key={index}
                    >
                      {/*<SlideUp>*/}
                      <li
                        key={index}
                        className="md:text-base text-sm hover:translate-x-4 hover:underline hover:text-theme-color transition-transform duration-200 mb-3 "
                      >
                        <Link to={`${settings.domain}${item.routePath}`}>
                          {/*{t(`services.${index}.title`)}*/}
                          {t(`common.${item.translateKey}`)}
                        </Link>
                      </li>
                      {/*</SlideUp>*/}
                    </div>
                  ))}
                </ul>
              </div>
              {/* Add second column or content here if needed */}
            </div>
          </div>
        </div>
        <div className="mid-footer md:mt-0">
          {/*<SlideUp>*/}
          {/*<div className="grid md:grid-cols-[60%_auto] lg:grid-cols-[45%_auto] bg-red-3000">*/}
          {/*  <div className="grid grid-cols-2 md:flex justify-start items-start gap-3 md:gap-5 lg:gap-10 bg-violet-3000">*/}
          {/*    <div className="flex flex-col items-start gap-1">*/}
          {/*      <div className="flex gap-2">*/}
          {/*        /!*{phoneIcon()}*!/*/}
          {/*        {phoneCalling('#0080FF')}*/}
          {/*        <div className="md:text-xl text-xl">{t('common.phone')}</div>*/}
          {/*      </div>*/}
          {/*      <div>*/}
          {/*        <ul className="my-2">*/}
          {/*          <li*/}
          {/*            className="text-sm theme-font-bold md:text-base hover:underline text-white hover:text-blue-800 transition-transform duration-200 flex flex-col items-start "*/}
          {/*          >*/}
          {/*            <a href="tel:+97142829613">+971 4 2829 613</a>*/}
          {/*          </li>*/}
          {/*          /!*<li*!/*/}
          {/*          /!*  className="text-sm md:text-base hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start "*!/*/}
          {/*          /!*>*!/*/}
          {/*          /!*  <a href="tel:+971505707868">+971 50 570 7868</a>*!/*/}
          {/*          /!*</li>*!/*/}
          {/*          /!*<li*!/*/}
          {/*          /!*  className="text-sm md:text-base hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start "*!/*/}
          {/*          /!*>*!/*/}
          {/*          /!*  <a href="tel:+97142821944">+971 4 2821 944</a>*!/*/}
          {/*          /!*</li>*!/*/}
          {/*        </ul>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div className="flex flex-col items-start gap-1">*/}
          {/*      <div className="flex gap-2">*/}
          {/*        <EmailEnvelopIcon color="#0080FF" pixel={33} />*/}
          {/*        <div className="md:text-xl text-xl">{t('common.email')}</div>*/}
          {/*      </div>*/}
          {/*      <div>*/}
          {/*        <ul className="">*/}
          {/*          <li*/}
          {/*            className="text-sm theme-font-bold md:text-lg hover:underline text-white hover:text-blue-800 transition-transform duration-200 flex flex-col items-start "*/}
          {/*          >*/}
          {/*            <a href="mailto:info@mesoft.ae">info@mesoft.ae</a>*/}
          {/*          </li>*/}
          {/*        </ul>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    /!*<div className=" col-span-2 flex flex-col items-start gap-1">*!/*/}
          {/*    /!*  <div className="flex gap-2">*!/*/}
          {/*    /!*    {<AddressPin color="#0080FF" pixel={27.5} />}*!/*/}
          {/*    /!*    <div className="md:text-xl text-xl">{t('common.location')}</div>*!/*/}
          {/*    /!*  </div>*!/*/}
          {/*    /!*  <div>*!/*/}
          {/*    /!*    <ul className="mt-2">*!/*/}
          {/*    /!*      <li*!/*/}
          {/*    /!*        className="md:text-base text-sm hover:underline hover:text-theme-color transition-transform duration-200 flex flex-col items-start "*!/*/}
          {/*    /!*      >*!/*/}
          {/*    /!*        /!*<a target="_blank" href="https://maps.app.goo.gl/WbUrhCfXrEvJPaYS7">{t('common.addressDescription')}</a>*!/*!/*/}
          {/*    /!*        <a*!/*/}
          {/*    /!*          target="_blank" href="https://maps.app.goo.gl/WbUrhCfXrEvJPaYS7"*!/*/}
          {/*    /!*          className="w-full flex flex-col justify-center items-start">*!/*/}
          {/*    /!*          /!*<div className="md:text-base text-sm">{t('common.addressDescription')}</div>*!/*!/*/}
          {/*    /!*          <div className="md:text-base text-sm">MESOFT Business Solutions L.L.C</div>*!/*/}
          {/*    /!*          <div className="md:text-base text-sm">P.O. Box: 5012, Airport Road (Near Terminal 1)</div>*!/*/}
          {/*    /!*          <div className="md:text-base text-sm">Dubai, United Arab Emirates.</div>*!/*/}
          {/*    /!*        </a>*!/*/}
          {/*    /!*      </li>*!/*/}
          {/*    /!*    </ul>*!/*/}
          {/*    /!*  </div>*!/*/}
          {/*    /!*</div>*!/*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*</SlideUp>*/}
        </div>
      </div>

      <div className="lower-footer bg-[#323231] text-white py-5 flex justify-between items-center">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center justify-between">
            <div className="flex gap-3 text-sm md:text-lg text-white">
              {t('common.copyRight')}  {new Date().getFullYear()}  @ Mesoft. {t('common.allRightReserved')}.
              <div>
                <Link
                  to={'/privacy-policy'}
                  className="text-sm md:text-lg hover:text-theme-color hover:underline underline text-gray-400">
                  {t('common.privacyPolicy')}
                </Link>
              </div>
            </div>
            <div className="social-div my-2 flex md:justify-end items-center bg-violet-9500">
              {/* Add social icons if needed */}
              <ul className="flex gap-5">
                <li>
                  <a href="https://mesoft.ae" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/facebook.png')}
                      alt="Facebook"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/mesoft-business-solutions-l-l-c/" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/linkedin.png')}
                      alt="LinkedIn"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://mesoft.ae" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/youtube.png')}
                      alt="YouTube"
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/mesoftuae/" target="_blank" rel="noopener noreferrer">
                    <img
                      className="w-10 h-10"
                      src={require('../../assets/images/logo/socials/insta-logo.png')}
                      alt="Instagram"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>|
      </div>
      <div
        className="fixed z-20 bg-green-400 shadow-lg w-12 h-12 md:w-14 md:h-14 md:right-20 md:bottom-20 right-5 bottom-5 rounded-full flex items-center justify-center">
        <a  rel="noreferrer" href="https://wa.me/971505707868?text=I'm%20interested" target="_blank" className="pulse w-12 h-12 md:w-14 md:h-14">
          <img src={require('../../assets/images/whatsapp.avif')} alt=""/>
        </a>
      </div>
    </div>
  );
};

export default Footer;
